import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { Vector, getDistances, isPointInside } from "tsparticles-engine";
export var DestroyOutMode = /*#__PURE__*/function () {
  function DestroyOutMode(container) {
    _classCallCheck(this, DestroyOutMode);

    this.container = container;
    this.modes = ["destroy"];
  }

  _createClass(DestroyOutMode, [{
    key: "update",
    value: function update(particle, direction, delta, outMode) {
      if (!this.modes.includes(outMode)) {
        return;
      }

      var container = this.container;

      switch (particle.outType) {
        case "normal":
        case "outside":
          if (isPointInside(particle.position, container.canvas.size, Vector.origin, particle.getRadius(), direction)) {
            return;
          }

          break;

        case "inside":
          {
            var _getDistances = getDistances(particle.position, particle.moveCenter),
                dx = _getDistances.dx,
                dy = _getDistances.dy;

            var _particle$velocity = particle.velocity,
                vx = _particle$velocity.x,
                vy = _particle$velocity.y;

            if (vx < 0 && dx > particle.moveCenter.radius || vy < 0 && dy > particle.moveCenter.radius || vx >= 0 && dx < -particle.moveCenter.radius || vy >= 0 && dy < -particle.moveCenter.radius) {
              return;
            }

            break;
          }
      }

      container.particles.remove(particle, undefined, true);
    }
  }]);

  return DestroyOutMode;
}();